import { Component, OnInit } from '@angular/core';
import {
  ErrorStateService,
  RegistrationStepService,
  StepType,
  MembershipOption,
  MembershipOptionQuery,
  RegistrationStepQuery,
} from '@fgb/core';
import { tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-registration-choose-membership-option-type',
  templateUrl: './registration-choose-membership-option-type.html',
  styleUrls: ['./registration-choose-membership-option-type.scss'],
})
export class RegistrationChooseMembershipOptionTypeComponent implements OnInit {
  readonly stepType = StepType.ChooseMembershipOption;
  hasSubmitted: boolean = false;
  today = new Date();
  membershipOptions$: Observable<MembershipOption[]>;
  selectedOptionItem: MembershipOption = {} as MembershipOption;

  constructor(
    private registrationStepService: RegistrationStepService,
    private registrationStepQuery: RegistrationStepQuery,
    private membershipOptionQueries: MembershipOptionQuery,
    public errorService: ErrorStateService
  ) {}

  ngOnInit() {
    this.registrationStepService
      .fetchRegistrationStepForCurrentWizard(StepType.ChooseMembershipOption)
      .pipe(
        tap(() => {
          this.membershipOptions$ = this.membershipOptionQueries
            .selectAll()
            .pipe(map(x => x.filter(y => y.WizardType === this.registrationStepQuery.getWizardType())));
        })
      )
      .toPromise();
  }

  submitStep() {
    let selectedOption: MembershipOption[] = [];
    selectedOption.push(this.selectedOptionItem);
    this.registrationStepService.submitRegistrationStepData(this.stepType, selectedOption).toPromise();
  }
}
